export default __webpack_public_path__ + "static/media/colorAndShape.dc5d04c5.png";